<template>
  <div>
    <div
      class="help-center-info-icon"
      :class="{'intercom_button': intercomEnabled, 'help-center-info-icon-hidden': !showHelpIcon}"
      @click="toggleHelpOptions"
      :style="{'--bottom-offset': offset + 'px'}">
      <div class="question-icon" title="Help and Support"><i class="fa-solid fa-comment-dots"></i></div>
    </div>
    <div v-if="!intercomEnabled && showHelpMenu" class="help-center-menu">
      <div class="close-icon" @click="toggleHelpOptions"><i class="fa-solid fa-x"></i></div>
      <div class="inner-help-box">
        <div class="help-header-text">Digital Customer Service</div>
        <div>For website, login issues and general support.</div>
        <div class="help-items">
          <div><a href="tel:+14047514400"> <i class="fa-light fa-phone"></i>404-751-4400</a></div>
          <div><a href="mailto:digital.customerservice@amwins.com"> <i class="fa-light fa-envelope"></i>Digital.customerservice@amwins.com</a></div>
          <div><span class="start-chat-btn" @click="chatClicked()"><i class="fa-light fa-comment-alt-lines"></i>Start Chat</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HelpCenterBubble',
  props: {
    intercomEnabled: {
      type: Boolean,
      default: false
    },
    showHelpIcon: {
      type: Boolean,
      default: false
    },
    offset: {
      type: String,
      default: '20'
    }
  },
  data () {
    return {
      showHelpMenu: false
    };
  },
  emits: [
    'chat-clicked'
  ],
  methods: {
    chatClicked () {
      this.showHelpMenu = false;
      this.$emit('chat-clicked');
    },
    toggleHelpOptions () {
      this.showHelpMenu = !this.showHelpMenu;
    }
  }
});
</script>

<style lang="scss" scoped>
.help-center-info-icon{
  position: fixed;
  bottom: var(--bottom-offset);
  right: 20px;
  background-color: #002B49;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #acacac;
  box-shadow: 0px 7px 16px 0px #00000045;
  opacity: 1;
  transition: opacity 0.5s;
  cursor: pointer;

  .question-icon {
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    margin-top: 12px;
    margin-left: 14px;
    font-size: 18px;
  }
}
.help-center-info-icon-hidden {
    opacity: 0;
}
.help-center-menu {
  z-index: 9999;
  position:fixed;
  bottom: 100px;
  right: 70px;
  border-radius: 20px;
  border: 1px solid;
  border-color: #A2D6E7;
  padding: 5px;
  box-shadow: 0px 7px 16px 0px #00000045;
  background-color: #FBFDFF;

  .close-icon {
    float: right;
    cursor: pointer;
    margin-right: 10px;
    margin-top: 5px;
    color: #888888;
    font-size: 12px;
  }
  .inner-help-box {
    background-color: white;
    padding: 20px;
    border: 1px solid;
    margin: 10px;
    margin-top: 30px;
    border-radius: 20px;
    border-color: #A2D6E7;
    font-size: 14px;

    .help-header-text{
      font-weight: bold;
      color: #002B49;
    }
    .help-items {
      padding: 10px;
      color: #215479;

      a {
        color: #215479;
      }

      svg {
        padding-right: 10px;
        color: #002B49;
      }

      .start-chat-btn{
        cursor: pointer;
        text-decoration: underline;
      }

      div{
        margin-top: 10px;
      }
    }
  }
}
</style>
